import { IconButton as AlphaIconButton } from '@oneaudi/unified-web-alpha-components';

export default AlphaIconButton;
